import styled from 'styled-components';

export const Container = styled.form`
  max-width: 1000px;
  width: 100%;
  margin: 0 auto;
`;
